import { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

const cardStyle = {
    style: {
        base: {
            color: '#e0e0e0',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            '::placeholder': { color: '#555' },
        },
        invalid: { color: '#ef4444' },
    },
};

const styles = {
    overlay: {
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000,
    },
    modal: {
        background: '#1a1a1a',
        border: '1px solid #2a2a2a',
        borderRadius: 12,
        padding: 32,
        width: '100%',
        maxWidth: 420,
    },
    title: { color: '#fff', fontSize: 18, fontWeight: 700, marginBottom: 8, marginTop: 0 },
    subtitle: { color: '#666', fontSize: 13, marginBottom: 24 },
    cardBox: {
        background: '#111',
        border: '1px solid #2a2a2a',
        borderRadius: 8,
        padding: '14px 16px',
        marginBottom: 20,
    },
    btn: (disabled) => ({
        width: '100%',
        background: disabled ? '#1a2a1a' : '#2563eb',
        color: disabled ? '#444' : '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '12px 0',
        fontSize: 14,
        fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
    }),
    error: { color: '#ef4444', fontSize: 13, marginTop: 12 },
    success: { color: '#4caf50', fontSize: 14, textAlign: 'center', padding: '20px 0' },
};

function SetupForm({ clientSecret, onSuccess }) {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setLoading(true);
        setError(null);

        const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
            payment_method: { card: elements.getElement(CardElement) },
        });

        if (stripeError) {
            setError(stripeError.message);
            setLoading(false);
            return;
        }

        const token = localStorage.getItem('token');
        await axios.post(`${API}/payments/save-method`,
            { payment_method_id: setupIntent.payment_method },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        setDone(true);
        setTimeout(onSuccess, 1000);
        setLoading(false);
    };

    if (done) return <p style={styles.success}>✓ Carte enregistrée !</p>;

    return (
        <form onSubmit={handleSubmit}>
            <div style={styles.cardBox}>
                <CardElement options={cardStyle} />
            </div>
            <button type="submit" disabled={!stripe || loading} style={styles.btn(!stripe || loading)}>
                {loading ? 'Enregistrement...' : 'Enregistrer ma carte'}
            </button>
            {error && <p style={styles.error}>{error}</p>}
        </form>
    );
}

export default function SetupCardModal({ onSuccess }) {
    const [clientSecret, setClientSecret] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        axios.post(`${API}/payments/setup-intent`, {}, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => setClientSecret(res.data.client_secret));
    }, []);

    if (!clientSecret) return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <p style={{ color: '#666', textAlign: 'center' }}>Chargement...</p>
            </div>
        </div>
    );

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h3 style={styles.title}>Enregistrez votre carte</h3>
                <p style={styles.subtitle}>Nécessaire avant de soumettre un ticket. Vous ne serez débité qu'à la fin de l'intervention.</p>
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <SetupForm clientSecret={clientSecret} onSuccess={onSuccess} />
                </Elements>
            </div>
        </div>
    );
}